import { render, staticRenderFns } from "./CardStyle.vue?vue&type=template&id=2b96074c&"
import script from "./CardStyle.vue?vue&type=script&lang=js&"
export * from "./CardStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports